import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";

const Return = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto my-10 max-w-container text-[14px] leading-10">
        <p className="mb-10 text-center text-[30px] uppercase text-btn">
          Elviroxab Leather Co Return Policy
        </p>
        <p>
          Elviroxab Leather gladly accepts returns and exchanges of merchandise
          purchased online within 30 days of the date the order shipped.
          Products must be in unused, resellable condition, to be eligible for a
          return. Refunds are issued after inspection and approval of returned
          items at the workshop and are only issued back to the original payment
          method.
        </p>
        <p>
          Products that are in used, like-new condition, will only qualify for
          exchanges. A store credit equal to the remaining balance will be
          issued on exchanges for items of lesser value.{" "}
        </p>
        <p>
          The shipping cost for returns and return portion of exchanges is the
          responsibility of the customer.{" "}
        </p>
        <p>To begin an exchange or return, please visit our Returns Portal. </p>
        <p>Monogrammed and Consumable Items </p>
        <p>
          Monogrammed/Personalized Items, Leather Creams and Leather Cleaners
          are final sale and are ineligible for return or exchange.{" "}
        </p>
        <p>Forever Guarantee</p>
        <p>
          We are proud to offer our Forever Guarantee on each of our products.
          We take pride in the craftsmanship and time-tested techniques used to
          hand craft each product. Because of this, if any product encounters a
          production defect or hardware failure, please contact us at
          contact@Elviroxableather.com. Please provide a brief description of
          the issue and be prepared to provide photos as well. If the product
          has experienced a defect or failure due to the manufacturing process,
          we are happy to repair it at no cost. If we are unable to repair the
          product, we will honor our forever guarantee with an exchange for a
          new product or by issuing a store credit.
        </p>
        <p>Repeated Returns</p>
        <p>
          We offer returns and exchanges because we know how difficult online
          shopping can be. Especially for items as personal as purses! However,
          repeated returns may be flagged and determined to be an abusive or
          exploitive use of our return policy. Flagged returns may, at our
          discretion, lead to the addition of restocking fees, rejection of
          returns, or the refusal of future orders.
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Return;
